import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

// 🔹 Globalni CSS (OBAVEZNO – bez ovoga neće biti stilova)
import './index.css';

// 🔹 Stranice
import App from './App.jsx';
import Home from './pages/Home.jsx';
import ProductList from './pages/ProductList.jsx';
import ProductDetail from './pages/ProductDetail.jsx';
import Admin from './pages/Admin.jsx';

// 🔹 Router definicija
const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      { path: '/', element: <Home lang="hr" /> },
      { path: '/en', element: <Home lang="en" /> },
      { path: '/hr/proizvodi', element: <ProductList lang="hr" /> },
      { path: '/en/products', element: <ProductList lang="en" /> },
      { path: '/hr/proizvod/:slug', element: <ProductDetail lang="hr" /> },
      { path: '/en/product/:slug', element: <ProductDetail lang="en" /> },
      { path: '/admin', element: <Admin /> },
    ],
    errorElement: (
      <div style={{
        padding: '4rem',
        textAlign: 'center',
        color: '#fff',
        background: '#0b1420',
        fontFamily: 'sans-serif'
      }}>
        <h1>404 – Stranica nije pronađena</h1>
        <p>Provjerite URL ili se vratite na <a href="/" style={{ color: '#d4af37' }}>početnu</a>.</p>
      </div>
    ),
  },
]);

// 🔹 Render aplikacije
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
